module.exports = __webpack_public_path__ + "img/before2.7b4c4358.jpg";